import { white, black } from "common/colors";  
import green from "@mui/material/colors/green";

export default {
  common: {
    black,
    white,
  },
  primary: {
    contrastText: white,
    main: "#012159", //#0767DB
    light: "#1aa7ff",
    dark: "#0B48A0",
    // Custom keys retained for existing styles (MUI ignores unknown keys)
    neutral: "#004fac",
    darkLight: "#B9CCE1",
    mediumLight: "#1aa7ff",
    darker: "#00225a",
    intense: '#000a1a',
    currentLightBlue: '#3d85c6',
    currentMailProColor: '#4A7396'
  },
  secondary: {
    contrastText: white,
    main: "#7d58ff",
    light: "#f2ebf7",
    dark: "#37248F",
  },
  info: {
    contrastText: white,
    main: "#1070CA",
    light: "#51A8F5",
    dark: "#007489",
  },
  warning: {
    contrastText: white,
    main: "#FFB822",
    light: "#FDF8F3",
    dark: "#95591E",
  },
  error: {
    contrastText: white,
    main: "#ED4740",
    light: "#FEF6F6",
    dark: "#BF0E08",
  },
  text: {
    primary: "#12161B",
    secondary: "#66788A",
    disabled: "#A6B1BB",
    green: "#45B880",
  },
  success: {
    contrastText: white,
    main: green["500"],
    light: "#F1FAF5",
    dark: "#00783E",
  },
  latestLightGreen: {
    main: "#ecfbfb",
    medium: "#d6eeec",
    dark: "#85cdc5",
  },
  background: {
    default: "#FBFBF5",        // body — layout shell: topbar, sidebar, drawer, body
    paper: white,
    lgScreenBg: "#f5f2df",     // screen — page backgrounds: ROI, Invoice, Year End Statement
  },
  // Provide a dedicated border color used by custom Portlet components
  border: "#DFE3E8",
  divider: "#DFE3E8",
  // Custom button color used in various legacy styles
  button: {
    main: "#4e85af",
  },
  // Provide a 'default' color to maintain compatibility with legacy
  // usages like <Button color="default" /> from MUI v4 era.
  // This prevents palette["default"].main from being undefined.
  default: {
    main: "#e0e0e0",
    light: "#f5f5f5",
    dark: "#9e9e9e",
    contrastText: "#000000",
  },
  grey: {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161',
    main: '#9e9e9e'
  }
};
